var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"w-full md:w-full py-2 h-full rounded-lg border px-2",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"blur":function($event){return _vm.change($event.target.value, _vm.Item)},"input":function($event){return _vm.$emit('input',$event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }